import React from "react";
import Checkbox from "../../../components/misc/Checkbox";
import { getDateAndTime } from "../../../utils/dateAndTime";
import { SubRouteDataInterface } from "../../../redux/interfaces/admin.interface";

function UserPermissionsTable({
  permissions,
  handleCheckRoute,
}: {
  permissions: SubRouteDataInterface[];
  handleCheckRoute: (routeId: number, checked: boolean) => void;
}) {
  return (
    <table className="w-full border-separate border-spacing-y-1 text-left [&_th]:px-3 [&_th]:py-3 [&_td]:px-3 [&_td]:py-1">
      <thead>
        <tr className="text-sm font-semibold text-muted-dark">
          <th scope="col">Permisiune</th>
          <th scope="col">Admin</th>
          <th scope="col">Data</th>
        </tr>
      </thead>
      <tbody className="text-sm font-medium text-slate-900">
        {permissions.map((route) => {
          return (
            <tr
              key={route.idRoute}
              className="transition-colors hover:bg-surface-hover focus-within:bg-surface-hover">
              <td width={"75%"} className="rounded-l-control">
                <Checkbox
                  label={route.routeLabel}
                  name={`${route.idRoute}`}
                  labelAlign="right"
                  onChange={(checked) =>
                    handleCheckRoute(route.idRoute, checked)
                  }
                  checked={route.isChecked}
                  withFullWidth={false}
                  className="min-h-[40px] gap-1 [&_input]:!h-6 [&_input]:!w-6"
                />
              </td>
              <td width={"15%"} className="whitespace-nowrap text-muted-dark">
                {route.userName ? `${route.userName} (${route.idAdmin})` : "-"}
              </td>
              <td
                width={"10%"}
                className="whitespace-nowrap rounded-r-control text-muted-dark">
                {route.userName ? getDateAndTime(route.addedAt) : "-"}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

export default UserPermissionsTable;
